// Dizzplace - interakcje podstrony produktowej. Bez zaleznosci, ES2020.

(() => {
  // Format kwoty ze sklepu. Ten sklep uzywa `{{amount_with_comma_separator}}`,
  // wiec podmiana samego `{{amount}}` zostawiala w przycisku surowy placeholder
  // po kazdej zmianie ilosci. Ten sam zestaw wariantow co w `sample-set.js`.
  const money = (cents, format) => {
    const kwota = (cents / 100).toFixed(2);
    const [calosc, ulamek] = kwota.split('.');
    const zSpacja = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const zKropka = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    const warianty = {
      amount: `${calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${ulamek}`,
      amount_no_decimals: calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: `${zKropka},${ulamek}`,
      amount_no_decimals_with_comma_separator: zKropka,
      amount_with_space_separator: `${zSpacja},${ulamek}`,
      amount_no_decimals_with_space_separator: zSpacja,
      amount_with_apostrophe_separator: `${calosc.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${ulamek}`,
    };

    if (!format) return warianty.amount_with_comma_separator;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, klucz) =>
      Object.prototype.hasOwnProperty.call(warianty, klucz) ? warianty[klucz] : ''
    );
  };

  // Galeria: klik w miniature, strzalka (komputer) albo przesuniecie palcem
  // po zdjeciu (telefon) podmienia duze zdjecie. Kolejnosc wyznaczaja
  // miniatury; po ostatnim kadrze wraca pierwszy.
  const initGallery = (root) => {
    const main = root.querySelector('[data-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    if (!main || !thumbs.length) return;

    const pasek = root.querySelector('.product-gallery__thumbs');
    const biezacy = () => Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));

    const pokaz = (i) => {
      const thumb = thumbs[(i + thumbs.length) % thumbs.length];
      const src = thumb.dataset.src;
      if (!src) return;
      main.src = src;
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      // Indeks wedruje na duze zdjecie, zeby powiekszenie otwieralo sie na
      // tym kadrze, ktory widac, a nie zawsze na pierwszym.
      if (thumb.dataset.indeks) main.dataset.indeks = thumb.dataset.indeks;
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
      // Aktywna miniatura ma byc widoczna w pasku; przewijamy sam pasek,
      // nie strone (scrollIntoView ruszaloby takze okno).
      if (pasek) {
        const x = thumb.offsetLeft - (pasek.clientWidth - thumb.offsetWidth) / 2;
        pasek.scrollTo({ left: Math.max(0, x), behavior: 'smooth' });
      }
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => pokaz(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => pokaz(biezacy() - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => pokaz(biezacy() + 1));

    const stage = root.querySelector('.product-gallery__stage');
    if (stage && thumbs.length > 1) {
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') pokaz(biezacy() - 1);
        if (e.key === 'ArrowRight') pokaz(biezacy() + 1);
      });

      // Przesuniecie palcem: liczy sie ruch wyraznie poziomy (min. 40 px
      // i wiekszy niz pionowy), pionowy zostaje przewijaniem strony
      // (`touch-action: pan-y` w arkuszu). Klik, ktory przychodzi zaraz po
      // przesunieciu, jest tlumiony w fazie przechwytywania - inaczej
      // otwieraloby sie powiekszenie.
      let start = null;
      let tlum = false;
      stage.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        start = { x: e.clientX, y: e.clientY };
      });
      stage.addEventListener('pointerup', (e) => {
        if (!start) return;
        const dx = e.clientX - start.x;
        const dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        pokaz(biezacy() + (dx < 0 ? 1 : -1));
        tlum = true;
        setTimeout(() => { tlum = false; }, 400);
      });
      stage.addEventListener('pointercancel', () => { start = null; });
      stage.addEventListener('click', (e) => {
        if (!tlum) return;
        e.stopImmediatePropagation();
        e.preventDefault();
      }, true);
    }

    const zoom = root.querySelector('[data-gallery-zoom]');
    if (zoom) {
      zoom.addEventListener('click', () => {
        root.querySelector('.product-gallery__stage')?.classList.toggle('is-zoomed');
      });
    }
  };

  // Licznik ilosci: minus, plus, dolna granica 1.
  const initStepper = (root) => {
    const input = root.querySelector('[data-stepper-input]');
    if (!input) return;
    const step = (delta) => {
      const min = Number(input.min || 1);
      const next = Math.max(min, (Number(input.value) || min) + delta);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    root.querySelector('[data-stepper-down]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-stepper-up]')?.addEventListener('click', () => step(1));
  };

  // Kalkulator: powierzchnia sciany na liczbe plyt i tubek kleju.
  const initCalculator = (root) => {
    const area = root.querySelector('[data-calculator-area]');
    const output = root.querySelector('[data-calculator-result]');
    const template = root.querySelector('[data-calculator-template]');
    if (!area || !output || !template) return;

    const panelArea = Number(area.dataset.panelArea) || 0;
    const glueCoverage = Number(area.dataset.glueCoverage) || 0;
    const pattern = template.textContent.trim();
    // Forma slowa po liczbie wedlug regul jezyka strony (po polsku one/few/many:
    // 1 plyte, 2 plyty, 5 plyt; w pozostalych jezykach one/other).
    const reguly = new Intl.PluralRules(document.documentElement.lang || 'pl');
    const slowo = (rodzaj, liczba) => {
      const forma = reguly.select(liczba);
      return template.getAttribute(`data-${rodzaj}-${forma}`)
        || template.getAttribute(`data-${rodzaj}-other`) || '';
    };

    const recalc = () => {
      const value = Number(String(area.value).replace(',', '.'));
      if (!value || value <= 0 || panelArea <= 0) {
        output.textContent = '';
        ileDodac = 0;
        if (dodaj) dodaj.hidden = true;
        return;
      }
      const panels = Math.ceil(value / panelArea);
      const glue = glueCoverage > 0 ? Math.ceil(value / glueCoverage) : 0;
      output.innerHTML = pattern
        .replace('__PANELS__', `<strong>${panels}</strong>`)
        .replace('__PANELS_WORD__', slowo('panels', panels))
        .replace('__GLUE__', `<strong>${glue}</strong>`)
        .replace('__GLUE_WORD__', slowo('glue', glue));
      // Sam wynik nie rusza ilosci (decyzja wlasciciela z 18 wrzesnia 2026) -
      // robi to dopiero przycisk „Dodaj N plyt do koszyka” pod wynikiem
      // (27 pazdziernika 2026, po trzech audytach na slepo z rzedu).
      ileDodac = panels;
      if (dodaj) {
        dodaj.textContent = (dodaj.dataset.label || '')
          .replace('__N__', String(panels))
          .replace('__WORD__', slowo('panels', panels));
        dodaj.hidden = false;
      }
    };

    // Ilosc z kalkulatora idzie do pola formularza zakupu (to samo, ktore
    // ustawia arkusz „Podaj ilosc” na telefonie, wiec cena w przycisku idzie
    // za nia), a formularz wysylamy przez requestSubmit z jego wlasnym
    // przyciskiem - szuflada koszyka lapie to samo zdarzenie `submit` co przy
    // zwyklym zakupie. requestSubmit nie robi klikniecia, wiec na telefonie
    // arkusz ilosci nie przechwytuje tego drugi raz.
    const dodaj = root.querySelector('[data-calculator-add]');
    let ileDodac = 0;
    dodaj?.addEventListener('click', () => {
      const form = document.getElementById('product-form');
      if (!form || ileDodac < 1) return;
      const pole = form.querySelector('[data-stepper-input]') || form.elements.quantity;
      const przycisk = form.querySelector('.product-cta .button-cta[type="submit"]') || form.querySelector('[type="submit"]');
      if (!pole || !przycisk || przycisk.disabled) return;
      pole.value = String(ileDodac);
      pole.dispatchEvent(new Event('change', { bubbles: true }));
      const lustro = document.querySelector('[data-qty-lustro]');
      if (lustro) lustro.value = String(ileDodac);
      form.requestSubmit(przycisk);
      const arkusz = root.closest('quantity-sheet');
      if (arkusz && typeof arkusz.zamknij === 'function') arkusz.zamknij();
    });

    area.addEventListener('input', recalc);
    recalc();
  };

  /* Kwoty, ktore maja isc za iloscia. Dotad byla tylko jedna - ta w przycisku
     zakupu - a na telefonie przycisk chowa sie POD arkuszem "Podaj ilosc"
     i klient zmienial ilosc, nie widzac, ile zaplaci. Dlatego liczymy KAZDY
     element z `data-cta-price`: cene w przycisku, cene w arkuszu i stojaca
     przy niej cene przekreslona. Kazdy niesie swoja cene jednostkowa, wiec
     przekreslona liczy sie od ceny sprzed przeceny, a nie od tej po. */
  const initCtaPrice = () => {
    const form = document.getElementById('product-form');
    if (!form || !document.querySelector('[data-cta-price]')) return;
    // Pole ilosci lezy POZA formularzem (w arkuszu "Podaj ilosc"), a wiaze je
    // z nim atrybut `form` - dlatego `form.querySelector` go nie widzi i trzeba
    // siegnac po kolekcje pol formularza.
    const input = form.querySelector('[data-stepper-input]') || form.elements.quantity;
    if (!input) return;

    const sync = () => {
      const qty = Math.max(1, Number(input.value) || 1);
      // Lista czytana za kazdym razem: arkusz "Podaj ilosc" i przyklejona karta
      // zakupu dokladaja swoje kwoty juz po pierwszym przejsciu.
      document.querySelectorAll('[data-cta-price]').forEach((target) => {
        const unit = Number(target.dataset.unitPrice);
        if (!unit) return;
        // Rabat firmowy naliczamy od SUMY linii, tak jak liczy go Shopify -
        // zaokraglenie raz od calosci, nie osobno od kazdej sztuki.
        const rabat = Number(target.dataset.b2bPercent) || 0;
        let suma = unit * qty;
        // Zaokraglamy KWOTE rabatu i odejmujemy - tak liczy linie Shopify.
        if (rabat > 0) suma -= Math.round((suma * rabat) / 100);
        target.textContent = money(suma, target.dataset.moneyFormat);
      });
    };

    if (input.dataset.cenaPodpieta !== '1') {
      input.dataset.cenaPodpieta = '1';
      input.addEventListener('change', sync);
      input.addEventListener('input', sync);
    }
    // Kalkulator ustawia ilosc jeszcze zanim ten nasluch powstanie, wiec cene
    // trzeba policzyc raz od razu - inaczej przycisk pokazuje cene jednej plyty.
    sync();
  };

  // Rozwijanie z animacja. Natywny <details> otwiera sie skokiem, wiec
  // przechwytujemy klik w belke i animujemy wysokosc tresci. Zamykanie musi
  // odlozyc zdjecie atrybutu "open" na koniec ruchu, inaczej tresc zniknie
  // od razu i nie bedzie czego animowac.
  const initRozwijanie = (el) => {
    const belka = el.querySelector('summary');
    const tresc = belka && belka.nextElementSibling;
    if (!belka || !tresc || el.dataset.animowane === '1') return;
    el.dataset.animowane = '1';

    const bezRuchu = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ustawienia = { duration: 240, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' };
    let ruch = null;

    belka.addEventListener('click', (zdarzenie) => {
      // Belka wylaczona w CSS (np. opis na telefonie) nie moze sie zwijac ANI
      // mysza, ANI klawiatura. `pointer-events: none` zatrzymuje tylko mysz,
      // wiec o zakazie decyduje tu ta sama regula CSS - jedno zrodlo prawdy,
      // czytane w chwili klikniecia, wiec dziala tez po zmianie szerokosci.
      if (window.getComputedStyle(belka).pointerEvents === 'none') {
        zdarzenie.preventDefault();
        return;
      }

      if (bezRuchu()) return;
      zdarzenie.preventDefault();
      if (ruch) ruch.cancel();

      if (!el.open) {
        el.open = true;
        const docelowa = tresc.scrollHeight;
        ruch = tresc.animate(
          [{ height: '0px', opacity: 0 }, { height: `${docelowa}px`, opacity: 1 }],
          ustawienia,
        );
        ruch.onfinish = () => { ruch = null; };
      } else {
        const obecna = tresc.scrollHeight;
        ruch = tresc.animate(
          [{ height: `${obecna}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
          ustawienia,
        );
        ruch.onfinish = () => {
          el.open = false;
          ruch = null;
        };
      }
    });
  };

  // Przyklejony pasek zakupu wchodzi dopiero przy opisie: wyzej prawdziwy
  // przycisk jest na ekranie, wiec drugi tylko zaslanialby tresc. Pasek
  // wjezdza, gdy opis wejdzie w ekran od dolu, i zostaje takze wtedy, gdy opis
  // wyjedzie gora (stad warunek na ujemna pozycje); po przewinieciu z powrotem
  // do gory chowa sie tak samo.
  const initStickyAtc = () => {
    const pasek = document.querySelector('[data-sticky-atc]');
    const opis = document.querySelector('.accordion__item--opis');
    if (!pasek || !opis || pasek.dataset.gotowy === '1') return;
    pasek.dataset.gotowy = '1';

    const obserwator = new IntersectionObserver(
      (wpisy) => {
        wpisy.forEach((wpis) => {
          const minieto = wpis.isIntersecting || wpis.boundingClientRect.top < 0;
          pasek.classList.toggle('sticky-atc--widoczny', minieto);
        });
      },
      { threshold: 0 }
    );

    obserwator.observe(opis);
  };

  // Dociecie plyt: ukryte _dociecie idzie do koszyka tylko razem z polem
  // (niesie nazwe wlasciwosci w jezyku dodania, patrz snippets/product-cutting).
  // Stan sprawdzany takze przy starcie - przegladarka przywraca zaznaczenie
  // po powrocie na strone, a atrybut disabled wraca z HTML.
  const initCutting = (pole) => {
    const znacznik = pole.parentElement.querySelector('[data-cutting-flag]');
    if (!znacznik) return;
    const sync = () => { znacznik.disabled = !pole.checked; };
    sync();
    if (pole.dataset.gotowy === '1') return;
    pole.dataset.gotowy = '1';
    pole.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
  };

  const init = () => {
    document.querySelectorAll('[data-cutting-checkbox]').forEach(initCutting);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-stepper]').forEach(initStepper);
    document.querySelectorAll('[data-calculator]').forEach(initCalculator);
    document.querySelectorAll('details.disclosure, details.accordion__item').forEach(initRozwijanie);
    initCtaPrice();
    initStickyAtc();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
